module.exports = __webpack_public_path__ + "static/0-c0cf2c7264f6ae31eb85a2dafef8200f.jpg";